var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
const ConditionalLink = (_a) => {
    var { disabled = false, onClick, children, className } = _a, rest = __rest(_a, ["disabled", "onClick", "children", "className"]);
    if (disabled)
        return children;
    return (_jsx("a", Object.assign({}, rest, { onClick: onClick, className: classNames('bold clickable', className) }, { children: children })));
};
export default ConditionalLink;
